import { z } from "zod";
import { AgentTypeMetadata } from "../../config/agent-registry";
import { baseAgentConfig } from "../../config/base-agent-config";

const virustotalConfigSchema = baseAgentConfig.extend({
  virustotalApiKey: z.string().optional().nullable(),
});

export const virustotalAgentMetaData: AgentTypeMetadata<
  typeof virustotalConfigSchema
> = {
  name: "Virustotal",
  description: "Check Links and Attachments through your Chat",
  category: "Misc",
  icon: "virustotal",
  type: "agent",
  version: "Released",
  ribbon: null,
  status: "Active",
  href: "/admin/ai-configuration/connectors/virustotal",
  instructions:
    "You are a VirusTotal agent. Help users scan files, URLs, and attachments for malware and security threats. You can analyze suspicious content and provide detailed security reports and recommendations.",
  placeholders: {
    virustotalApiKey: "Enter your VirusTotal API key (optional)",
  },
  configSchema: virustotalConfigSchema,
  sensitiveKeys: ["virustotalApiKey"],
};
